Apt.fn.make('sell', {
	/**
	 * Initialize module
	 */
	init() {
		const scope = this;

		scope.message = Apt.fn.message()
			.init({
				placeholder: 'Tell us about your property',
				button: 'Get started',
				required: true
			});

		scope.$private.initModals();
	},

	/**
	 * Unload module
	 */
	unload() {
		LS.util.reset('advertise', this, [
			'message'
		]);
	}
}, {
	/**
	 * Initialize modals
	 */
	initModals() {
		$$('sellModal').on('click', (e, el) => {
			LS.util.view('sell', el.dataset.view, template => {
				LS.modal.open({
					model: {
						title: el.dataset.title,
						content: template
					},
					width: 520
				});
			});
		}, {
			namespace: 'sell'
		});
	}
});